module.exports = __webpack_public_path__ + "static/media/nous-recrutons.c4539eec.png";